import { defineComponent as _defineComponent } from 'vue'
import { Box } from '@/ui/components/Box';
  import DarkContactUs from '@/ui/components/button/DarkContactUs.vue';
  import EmptyStateEntry from '@/ui/pages/EmptyStateEntry';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'AddonPromo',
  props: {
    title: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: false,
    },
    imageSrc: {
      type: String,
      required: true,
    },
  },
  setup(__props) {

  

return { __sfc: true,Box, DarkContactUs, EmptyStateEntry }
}

})